import {ArrowRight} from "react-feather";
import {Card} from "flowbite-react";
import webinarPlaceholder from "../../../images/webinar-placeholder.png";
import playButton from "../../../images/svg/broker/play-button.svg";
import { moment } from "../../../services/moment-extensions";

const WebinarCard = ({webinar, setWebinarSelected, setWebinarVideoAutoplay, index}) => {

    const momentDate = moment(webinar.start_datetime);
    const formattedDate = momentDate.toLocaleDateTimeMedium().replace(/,([^,]*)$/, ' at$1') + ' CST';
    const isPast = moment(webinar.start_datetime).isBefore(moment());

    return <Card className={"sl-flex sl-flex-col sl-justify-flex-start sl-w-98"}
                 theme={{
                     root: {
                         children: 'grid h-full flex-col sl-gap-5 sl-p-3 sl-cursor-pointer sl-shadow-lg-hover',
                     }
                 }}>

        <div className={"sl-flex sl-flex-col sl-width-100"}>
            <div className={"sl-width-100 sl-border-radius-8 sl-mb-3 sl-h-200 sl-overflow-hidden sl-relative"}
                 onClick={() => {
                     setWebinarSelected(webinar);
                     if (webinar.video_link) {
                         setWebinarVideoAutoplay(true);
                     }
                 }}
            >
                <img alt={webinar.title}
                     src={webinar.featured_image ? webinar.featured_image.preview : webinarPlaceholder}
                     className={"sl-img sl-width-100 sl-position-center"}
                />
                {webinar.video_link && isPast && (
                    <div
                        className="sl-absolute sl-width-100 sl-h-full sl-flex sl-align-center sl-justify-center sl-top-0 sl-left-0"
                        style={{background: "rgba(0, 0, 0, 0.2)"}}>
                        <img alt={"Webinar play button"} src={playButton}/>
                    </div>
                )}
            </div>
            <div className={"sl-pb-2 sl-flex sl-flex-col sl-text-left"}>
                <span className={"sl-text-xs sl-text-primary-600 sl-font sl-font-semibold"}>{webinar.vendor.name}</span>
                <span onClick={() => setWebinarSelected(webinar)}
                      className={"sl-text-xl sl-font sl-font-semibold sl-text-gray-900"}>{webinar.title}</span>
                <span className={"sl-font sl-text-sm sl-font-medium sl-text-gray-600 sl-mt-2"}>{formattedDate}</span>
            </div>
        </div>

        <div onClick={() => setWebinarSelected(webinar)}
            className={"sl-flex sl-align-end"}>
            <button
                className={"sl-btn-primary sl-btn sl-flex sl-flex-row sl-p-4 sl-align-self-end sl-w-fit-content sl-py-10px sl-gap-2"
                    + (webinar.has_registered && !isPast ? " sl-btn-disabled" : "")}>
                <span className={"sl-font sl-text-sm sl-font-medium"}>
                    {isPast ? "Watch Recording" : (webinar.has_registered ? "Registered" : "Register")}
                </span>
                <ArrowRight size={20} className={"sl-text-white"}/>
            </button>
        </div>
    </Card>
}

export default WebinarCard;
